export const Preview = () => {
    return (
        <section className="section-shell">
            <div className="section-block">
                <p className="section-body mb-8">
                    D&Dream Property Group was established in the year 2017,
                    October 1st and constantly expanding the team nationwide to
                    be the leading property agency in Malaysia. Through the
                    years of hard work and dedication, D&Dream Property Group
                    has obtained recognition from the market:
                </p>
                <img
                    className="w-full h-auto"
                    src="https://venti-fans.com/wp-content/uploads/2025/03/DD_WebsiteIcons-02_icF9qp5Yn-scaled.webp"
                    alt=""
                />
            </div>

            <div className="section-block">
                <h2 className="section-title">Vision</h2>
                <p className="section-body">
                To become Malaysia’s strongest real estate agency, built on the principles of equality, merit, and profit sharing, where everyone has the opportunity to grow, succeed, and lead.
                </p>
            </div>

            <div className="section-block">
                <h2 className="section-title">Mission</h2>
                <p className="section-body">
                To provide a comprehensive real estate platform that empowers the next generation of real estate professionals through abundant opportunities, continuous development, and 100% advance commission, enabling them to thrive and stand out in the industry.
                </p>
            </div>

            <hr className="section-rule" />

            <div className="section-block section-block--wide">
                <h2 className="section-title">BENEFITS</h2>
                <div className="benefit-grid">
                    <div className="benefit-item">
                        <img
                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteBenefitIcons_%20_a-Bn2frvL.png?updatedAt=1739983372980"
                            alt="ptp1comm"
                        />
                        <div>Car Subsidy Up To RM12,000</div>
                        <div className="benefit-item-cn">12,000的汽车津贴</div>
                    </div>
                    <div className="benefit-item">
                        <img
                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteBenefitIcons-02_dMX3UZyodF.png?updatedAt=1739983372983"
                            alt="ptp1comm"
                        />
                        <div>100% All Commissions</div>
                        <div className="benefit-item-cn">
                            100%经纪，领导，至尊领导佣金
                        </div>
                    </div>
                    <div className="benefit-item">
                        <img
                            src="https://venti-fans.com/wp-content/uploads/2025/03/DD_WebsiteBenefitIcons-03_Vsy084Jmf.webp"
                            alt="ptp1comm"
                        />
                        <div>3 Days 100% Comm.</div>
                        <div className="benefit-item-cn">3天100%佣金</div>
                    </div>
                    <div className="benefit-item">
                        <img
                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteBenefitIcons-04_ky6dqn1a-.png?updatedAt=1739983372808"
                            alt="ptp1comm"
                        />
                        <div>Oversea Incentive Trips</div>
                        <div className="benefit-item-cn">海外旅行</div>
                    </div>
                    <div className="benefit-item">
                        <img
                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteBenefitIcons-05_AOy9Mn09CF.png?updatedAt=1739983372781"
                            alt="ptp1comm"
                        />
                        <div>Exclusive D&D Projects</div>
                        <div className="benefit-item-cn">简易开单项目</div>
                    </div>
                    <div className="benefit-item">
                        <img
                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteBenefitIcons-06_vdlR23Xqa.png?updatedAt=1739983372906"
                            alt="ptp1comm"
                        />
                        <div>Group Profit Sharing</div>
                        <div className="benefit-item-cn">富过三代计划</div>
                    </div>
                    <div className="benefit-item">
                        <img
                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteBenefitIcons-07_vZ8aIgkhe.png?updatedAt=1739983372763"
                            alt="ptp1comm"
                        />
                        <div>1-1 Leadership & Team Trainings</div>
                        <div className="benefit-item-cn">一对一培训计划</div>
                    </div>
                    <div className="benefit-item">
                        <img
                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteBenefitIcons-08_CMKezNeaV.png?updatedAt=1739983372768"
                            alt="ptp1comm"
                        />
                        <div>Image Branding Training</div>
                        <div className="benefit-item-cn">形象品牌培训课程</div>
                    </div>
                    <div className="benefit-item">
                        <img
                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteBenefitIcons-09_hmemZzAqUa.png?updatedAt=1739983372772"
                            alt="ptp1comm"
                        />
                        <div>Relax Co-Working Space Provided</div>
                        <div className="benefit-item-cn">舒适共用工作空间</div>
                    </div>
                </div>
            </div>
        </section>
    );
};
